export default __webpack_public_path__ + "static/media/ico_pass_off.edc7a487.svg";